var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.155,
    height: 103.524,
    viewBox: "0 0 114.155 103.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.194,
    y1: 0.21,
    x2: 1.22,
    y2: 1.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-truck",
    x: 0,
    y: 0,
    width: 114.155,
    height: 103.524,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-truck)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-truck-2",
    "data-name": "Icon awesome-truck",
    d: "M51.826,29.235H50.5V20.257a3.987,3.987,0,0,0-1.171-2.816l-8.3-8.3a3.987,3.987,0,0,0-2.816-1.171H34.551V3.987A3.988,3.988,0,0,0,30.564,0H3.987A3.988,3.988,0,0,0,0,3.987V30.564a3.988,3.988,0,0,0,3.987,3.987H5.316a7.973,7.973,0,1,0,15.947,0H31.893a7.973,7.973,0,1,0,15.947,0h3.987a1.333,1.333,0,0,0,1.329-1.329V30.564A1.333,1.333,0,0,0,51.826,29.235Zm-38.538,9.3a3.987,3.987,0,1,1,3.987-3.987A3.988,3.988,0,0,1,13.289,38.538Zm26.578,0a3.987,3.987,0,1,1,3.987-3.987A3.988,3.988,0,0,1,39.866,38.538Zm6.644-17.275H34.551v-9.3h3.663l8.3,8.3Z",
    transform: "translate(25.5 25.5)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.91f9bf5337e4b8e2ceec4174e2682953.svg";
export { ForwardRef as ReactComponent };